import { useState } from 'react';

/**
 * الأحدث إنشاءً أولًا وصفحاتٌ مرقّمة تُقصد مباشرة.
 *
 * خطّاف واحد لكل قوائم السجلّ — أنشطة الملف وملاحظات الفريق والمرفقات —
 * فلا يختلف الترتيب ولا شكل الأرقام بين قائمةٍ وأخرى. الترتيب بالإنشاء
 * لا بالاستحقاق: ما أُضيف الآن يُرى الآن في صدر القائمة، والقديم ينزل —
 * كما تُقرأ السجلات.
 */
export function usePagedNewestFirst<T extends { createdAt?: string | null }>(
  items: T[],
  pageSize = 10,
): { shown: T[]; pager: React.ReactNode } {
  const [page, setPage] = useState(1);

  const sorted = [...items].sort((a, b) => ((a.createdAt ?? '') < (b.createdAt ?? '') ? 1 : -1));
  const pageCount = Math.max(1, Math.ceil(sorted.length / pageSize));
  const safePage = Math.min(page, pageCount);
  const shown = sorted.slice((safePage - 1) * pageSize, safePage * pageSize);

  const pager =
    pageCount > 1 ? (
      <div className="row" style={{ gap: 4, flexWrap: 'wrap', paddingTop: 'var(--sp-2)' }}>
        {Array.from({ length: pageCount }, (_, i) => i + 1).map((n) => (
          <button
            key={n}
            type="button"
            className={`btn btn-sm num${n === safePage ? ' btn-primary' : ''}`}
            onClick={() => setPage(n)}
            aria-label={`الصفحة ${n}`}
            aria-current={n === safePage ? 'page' : undefined}
          >
            {n}
          </button>
        ))}
      </div>
    ) : null;

  return { shown, pager };
}
